import * as React from 'react';
import BackButtonIcon from '../../images/icons/back-button-icon';
import * as styles from './styles.module.scss';
import { AppContext } from '../../shared/app-context';
import { Redirect, withRouter } from 'react-router-dom';
import Paths from '../../models/enums/paths';

const BackButton = ({ location }) => {
  const { state } = React.useContext(AppContext);
  const [redirect, setRedirect] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (redirect) {
      setRedirect(false);
    }
  }, [redirect]);

  if (redirect) {
    return <Redirect to={location.state && location.state.redirect ? location.state.newPath : Paths.Home} />;
  }

  return (
    <span
      className={state.globalAnnouncement ? styles.backButtonAnnouncement : styles.backButton}
      onClick={() => setRedirect(true)}
    >
      <BackButtonIcon width={'38px'} height={'38px'} />
    </span>
  );
};

export default withRouter(BackButton);
